import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link , useHistory} from "react-router-dom"
import { isEmpty, result, size } from "lodash"
import * as moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import classNames from "classnames"
import { AvForm, AvField } from "availity-reactstrap-validation"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {showSuccessToast} from "helpers/function_helper"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
//redux
import { useSelector, useDispatch } from "react-redux"
import SweetAlert from "react-bootstrap-sweetalert"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getCashInputList } from "helpers/backend_helper"
import { deletePurchasePaymentEntry } from "helpers/backend_helper"
import { deleteItemDirect as onDeleteItemDirect } from "helpers/backend_helper"
import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import Loader from "components/Common/Loader"
//import SalesListFilter from "../../components/Common/SalesListFilter"

const CashInputList = props => {
  const history = useHistory()

  useEffect(() => {
    getCashInputListLocal()
  }, []);

  async function getCashInputListLocal(){
    setShowLoading(true)
    getCashInputList().then(result => {
      setExpenseList(result)
      setShowLoading(false)
    })
  }


  const [modal, setModal] = useState(false)

  const [expenseList, setExpenseList] = useState([])

  const [showDeletePopUp, setShowDeletePopUp] = useState(false)
  const [showErrorPopUp, setShowErrorPopUp] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [deleteMessage, setDeleteMessage] = useState('')
  const [itemToDelete, setItemToDelete] = useState()
  const [showLoading, setShowLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  
  const [showReceipt, setShowReceipt] = useState(false)

  //pagination customization
  const pageOptions = {
    sizePerPage: 20,
    totalSize: size(expenseList), 
    custom: true,
    onPageChange: (page, sizePerPage) => {
      setCurrentPage(page)
    }
  }

  const { SearchBar } = Search

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const CashInputListColumns = () => [
    {
      dataField: "id",
      text: "#",
      sort: true,
      sortValue: (cell, row) => Number(cell),
    },
    {
      dataField: "receiptdate",
      text: "Date",
      sort: true,
      formatter: (cellContent, row) => handleValidDate(cellContent),
      filterValue: (cellContent, row) => handleValidDate(cellContent),
    },
    {
      dataField: "cashpaid",
      text: "Amount",
      sort: true,
      formatter: (cellContent, row) => (
      <div>
        {Number(cellContent).toLocaleString('en-IN',{minimumFractionDigits: 2})}
      </div>
      ),
    },
    {
      dataField: "comments",
      text: "Comments",
      sort: true,
      formatter: (cellContent, row) => (
        <div>
          {(cellContent)}
        </div>
        ),
    },
    {
      dataField: "paymentaccountid",
      text: "Account",
      sort: true,
      formatter: (cellContent, row) => (
        <div>
          {(cellContent)}
        </div>
        ),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      formatter: (cellContent, item) => (
        <>

        {<UncontrolledDropdown>
          <DropdownToggle
            href="#"
            className="card-drop pointer-cursor"
            tag="i"
            onClick={(e) => {e.stopPropagation()}}
          >
            <i className="mdi mdi-dots-horizontal font-size-18" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem
              onClick={() => handleDeleteClick(item)}
            >
              <i className="bx bx-trash-alt font-size-16 text-danger me-1" />{" "}
              Delete
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
        }
        </>
      ),
    },
  ]

  const handleDeleteClick = arg => {
    setItemToDelete(arg)
    setDeleteMessage(arg.cashpaid)
    setShowDeletePopUp(true)
  }

  const confirmDelete = async () =>{
    setShowDeletePopUp(false)
    setShowLoading(true)

    const response =  await onDeleteItemDirect({
      'key': itemToDelete.id,
      'value' : 'CashInput'
    }, '')

    setShowLoading(false)
    if(response.status == 'success'){
      showSuccessToast('Deleted Successfully!!!')
      getCashInputListLocal()
    }
    else if(response.status == 'failure'){
      setErrorMessage(response.errorResponse)
      setShowErrorPopUp(true)
    }
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  const toggle = () => {
    setModal(!modal)
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>View All Cash Input | Flamingo</title>
        </MetaTags>
        {!showReceipt && <Container fluid>
          <Breadcrumbs title="Expense" breadcrumbItem="All Expenses" />
          <Loader showLoader={showLoading} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={CashInputListColumns()}
                    data={expenseList}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        data={expenseList}
                        columns={CashInputListColumns()}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="6">
                              <div className={classNames({"d-none": currentPage !== 1},"search-box me-2 mb-2 d-inline-block")}>
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="6">
                                <div className="text-sm-end">
                                  <Link
                                    to="/add-cash-input"
                                    role="button"
                                    className="btn btn-success btn-rounded  mb-2 me-2"
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Add New Cash Input
                                  </Link>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive min-height-200">
                                  <BootstrapTable
                                    keyField="id"
                                    responsive
                                    //selectRow={selectRow}
                                    bordered={false}
                                    striped={false}
                                    //defaultSorted={defaultSorted}
                                    classes={
                                      "table align-middle table-hover"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    noDataIndication={<div className="text-center">- No results found -</div>}
                                  />
                                </div>
                                
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>}

      </div>

      {showDeletePopUp ? (
        <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDelete()
          }}
          onCancel={() => {
            setShowDeletePopUp(false)
          }}
        >
          <p>Deleting Cash Input entry of : <b>{deleteMessage}</b></p>
          You won't be able to revert this!
        </SweetAlert>
      ) : null}
      {showErrorPopUp ? (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => {
            setShowErrorPopUp(false)
          }}
        >
          {errorMessage}
        </SweetAlert>
      ) : null}
    </React.Fragment>
  )
}

CashInputList.propTypes = {
  cashInputList: PropTypes.array,
}

export default withRouter(CashInputList)
